<!-- 字典选择 -->
<template>
  <div class="body">
    <el-select v-model="selectId" :placeholder="placeholder" :disabled="disabled" size="small">
      <el-option v-for="item in dicList" :key="item.dicId" :label="item.cnName" :value="item.dicId" />
    </el-select>
  </div>
</template>

<script>
import dicService from "@/CommonDP/service/dic-service";
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    dicCode: {
      // 字典code
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dicList: [],
      selectId: this.value || ""
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      if (this.dicCode === "") return;
      const res = await dicService.getDicList(this.dicCode);
      this.dicList = res.data || [];
    },
    getSelectId() {
      return this.selectId;
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  width: 100%;
}
</style>
